import { render, staticRenderFns } from "./HubConfig.vue?vue&type=template&id=dadb0176&scoped=true&"
import script from "./HubConfig.vue?vue&type=script&lang=js&"
export * from "./HubConfig.vue?vue&type=script&lang=js&"
import style0 from "./HubConfig.vue?vue&type=style&index=0&id=dadb0176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadb0176",
  null
  
)

export default component.exports